/* eslint-disable @typescript-eslint/no-explicit-any */
import { Cordinate, PointLookupResult, DrawToolTipArgs, CoreTransform } from './CommonTypes';
import { MouseEvent } from 'react';
import Calculator from './Calculator';
import { StatusContextInterface, OnChange, OnClick, NodeChange } from './FormContext';

export default class MouseWatcher {
  constructor(calc: Calculator, SC: StatusContextInterface) {
    this.calc = calc;
    this.SC = SC;
  }
  SC: StatusContextInterface;
  mounted = false;
  timer = 400;
  transform: CoreTransform = { x: 0, y: 0, k: 1 }

  calc: Calculator;
  div: HTMLDivElement | undefined;

  down: { [key: string]: number } | null = null;
  lastMo: { [key: string]: number } | null = null;
  drag: { [key: string]: number } | null = null;
  timeout: any = null;
  tp: Cordinate | undefined | null;

  dragTarget: PointLookupResult | null | undefined = null;

  pd(e: React.MouseEvent<HTMLDivElement, MouseEvent>) {
    e.preventDefault();
    e.stopPropagation()
  }
  buildXY(event: { clientX: number, clientY: number }) {
    const { calc, div } = this;
    const { top, left, width, height } = div!.getBoundingClientRect();
    const xS = calc.initSize.width / width;
    const yS = calc.initSize.height / height;
    const x = event.clientX - left
    const y = event.clientY - top;
    const cor = {
      rx: x,
      ry: y,
      x: x * xS,
      y: y * yS,
      yS,
      xS,
      top,
      left,
      ex: event.clientX,
      ey: event.clientY,
    }
    return cor;
  }

  onMouseLeave = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    this.pd(e);
    if (this.down) {
      if (this.drag) {
        this.onDragEnd();
      }
      this.drag = null;
      this.down = null;
      this.dragTarget = null;
    }
    clearTimeout(this.timeout)
  }
  onMouseEnter = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    this.pd(e);
  }

  onWheel = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    this.pd(e)
    if (this.down) return;
    if (this.calc.noChange) return;
    const { deltaY } = e as unknown as WheelEvent;
    const { calc } = this;
    if (deltaY > 0) {
      calc.scaleSize(calc.transform.k - .05);
    } else {
      calc.scaleSize(calc.transform.k + .05);
    }

    const data = this.calc.getChanges();
    const event = new OnChange({ data, tag: 'onWheel' });
    this.SC.sendEvent(event, data);
  }

  onMousMove = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    this.pd(e)
    clearTimeout(this.timeout);
    this.calc.clearCtrl();
    if (this.down) {
      this.drawToolTip(null);
      if (this.drag) {
        this.onDrag(e);
      } else {
        this.drag = this.buildXY(e);
        this.onDragStart();
      }
    } else {
      this.drag = null;
      this.drawToolTip(null);
      this.timeout = setTimeout(() => this.onMouseOver(e), this.timer);
    }
  }

  onMouseOver = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const p = this.lastMo = this.buildXY(e);
    const res = this.calc.lookupPoint(p);
    this.calc.drawHighlight(res, { x: p.rx, y: p.ry });
  }

  onShowToolTip = (params: { id: string, [key: string]: any }) => {
    if (!this.lastMo) return;
    const { ex, ey } = this.lastMo;
    const { id } = params;
    this.drawToolTip({ id, x: ex, y: ey });
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  drawToolTip = (args: DrawToolTipArgs) => {

  }

  onMouseDown = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    this.pd(e)
    this.down = this.buildXY(e);
  }

  onMouseUp = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    this.pd(e);
    if (this.down) {
      this.down = null;
      if (this.drag) {
        this.drag = null;
        this.onDragEnd();
      } else {
        const pos = this.buildXY(e);
        const res = this.calc.lookupPoint(pos);
        if (res.type != 'none') {
          if (this.calc.noChange) return;
          const { type } = res;
          let tag = type;
          if (type == 'link' && res.link !== null) {
            tag += '-' + res.link.l.i;
          } else if (type == 'node' && res.node !== null) {
            tag += '-' + res.node.i;
          } else if (type == 'bundle' && res.bundle !== null) {
            tag += '-' + res.bundle.i;
          } else {
            return;
          }
          const event = new OnClick({ data: res, tag });
          this.SC.sendEvent(event, this.calc.getChanges());
        }
      }
    }
  }

  lastTp: Cordinate={x:0,y:0};
  onDragStart() {
    if (this.drag === null) return;
    const res = this.calc.lookupPoint(this.drag as Cordinate);
    this.transform = { ...this.calc.transform }

    this.calc.drag = true;
    this.lastTp=this.tp = res.tp;
    if (res.type != 'none') {
      this.dragTarget = res;
    }
  }

  getMoveDiff(e: React.MouseEvent<HTMLDivElement, MouseEvent>) {
    const pos = this.buildXY(e);
    const { drag } = this;
    const xDiff = pos.x - drag!.x;
    const yDiff = pos.y - drag!.y;
    return { xDiff, yDiff, pos };
  }

  onDrag(e: React.MouseEvent<HTMLDivElement, MouseEvent>) {
    const { calc, dragTarget } = this;

    if (dragTarget) {
      const pos = this.buildXY(e);
      const p = calc.translateCanvasYX(pos);
      if (dragTarget.type == 'node') {
        calc.moveNode(dragTarget.node!.i, p);
      } else {
        const p = calc.translateCanvasYX(pos);
        const {lastTp}=this;
        const diff: Cordinate={
          x: p.x - lastTp.x,
          y: p.y - lastTp.y,
        }
        calc.moveLink(dragTarget, diff);
        this.lastTp=p;
      }
    } else {
      const { xDiff, yDiff } = this.getMoveDiff(e);
      const { x, y } = this.transform;
      const sx = {
        x: xDiff + x,
        y: yDiff + y,
      }
      calc.moveCanvas(sx);
    }
  }

  onDragEnd() {
    const dt = this.dragTarget;
    this.dragTarget = null;
    this.tp = null;
    if (this.calc.noChange) return;
    const data = this.calc.getChanges();
    let event;
    if (dt) {
      this.calc.drag = false;
      if (dt.type == 'node') {
        event = new NodeChange({ data: dt, tag: `node-${dt.node!.i}` });
        event.name = 'NodeDrag';
        this.calc.moveNode(dt.node!.i, data.nodes[dt.node!.i]);
      } else {
        let tag = '';
        this.calc.moveLink(dt, {x:0,y:0});
        let name='';
        if (dt.type == 'link') {
          tag = `link-${dt.link!.l.i}`
          name='OnLinkChange'
        } else {
          name='OnBundleChange'
          tag = `bundle-${dt.bundle!.i}`
        }
        event = new OnChange({ data, tag });
        event.name=name;
      }
    } else {
      event = new OnChange({ data, tag: 'onMapDrag' });
    }
    this.calc.forceDraw();
    this.SC.sendEvent(event, data);
  }

  onNode = (node: HTMLDivElement) => {
    clearTimeout(this.timeout)
    if (node == null) {
      this.mounted = false;
      this.cleanup();
    } else {
      this.mounted = true;
      this.cleanup();
      this.setup(node);
    }
  }

  cleanup() {
    const { div } = this;
    if (!div) return;
    this.drivers.forEach(({ event, method }) => {
      div.removeEventListener(event as keyof EventListener, method)
    })
  }

  setup(div: HTMLDivElement) {
    this.div = div;
    this.drivers.forEach(({ event, method, opt }) => {
      div.addEventListener(event as keyof EventListener, method, opt);
    })
  }
  drivers = [
    { event: 'wheel', method: this.onWheel, opt: { passive: false } },
    { event: 'mouseenter', method: this.onMouseEnter, opt: { passive: false } },
    { event: 'mouseleave', method: this.onMouseLeave, opt: { passive: false } },
    { event: 'mousemove', method: this.onMousMove, opt: { passive: false } },
    { event: 'mouseup', method: this.onMouseUp, opt: { passive: false } },
    { event: 'mousedown', method: this.onMouseDown, opt: { passive: false } },
  ];

  static startup(calc: Calculator, SC: StatusContextInterface, setTT: (args: DrawToolTipArgs) => void) {
    const o = new MouseWatcher(calc, SC);
    calc.drawToolTip = o.drawToolTip = setTT;
    return o;
  }
}